module.exports = __webpack_public_path__ + "static/media/CeraPro-Light.95035220.woff2";